import { Container_KSK1030_R01 } from "src/containers/mes/KSK/KSK1030_R01/Container_KSK1030_R01";
import { Container_KSK1070_R01 } from "src/containers/mes/KSK/KSK1070_R01/Container_KSK1070_R01";
import { Container_KSK1080_R01 } from "src/containers/mes/KSK/KSK1080_R01/Container_KSK1080_R01";
import { Container_KSK1081_R01 } from "src/containers/mes/KSK/KSK1081_R01/Container_KSK1081_R01";
import { Container_KSK1090_R01 } from "src/containers/mes/KSK/KSK1090_R01/Container_KSK1090_R01";
import { Container_KSK1110_R01 } from "src/containers/mes/KSK/KSK1110_R01/Container_KSK1110_R01";
import { Container_KSK1120_R01 } from "src/containers/mes/KSK/KSK1120_R01/Container_KSK1120_R01";
import { Container_KSK2010_R01 } from "src/containers/mes/KSK/KSK2010_R01/Container_KSK2010_R01";
import { Container_KSK2011_R01 } from "src/containers/mes/KSK/KSK2011_R01/Container_KSK2011_R01";
import { Container_KSK2020_R01 } from "src/containers/mes/KSK/KSK2020_R01/Container_KSK2020_R01";
import { Container_KSK2021_R01 } from "src/containers/mes/KSK/KSK2021_R01/Container_KSK2021_R01";
import { Container_KSK2022_R01 } from "src/containers/mes/KSK/KSK2022_R01/Container_KSK2022_R01";
import { Container_KSK2030_R01 } from "src/containers/mes/KSK/KSK2030_R01/Container_KSK2030_R01";
import { Container_KSK2040_R01 } from "src/containers/mes/KSK/KSK2040_R01/Container_KSK2040_R01";
import { Container_KSK2070_R01 } from "src/containers/mes/KSK/KSK2070_R01/Container_KSK2070_R01";
import { Container_KSK2080_R01 } from "src/containers/mes/KSK/KSK2080_R01/Container_KSK2080_R01";
import { Container_KSK2090_R01 } from "src/containers/mes/KSK/KSK2090_R01/Container_KSK2090_R01";
import { Container_KSK2101_R01 } from "src/containers/mes/KSK/KSK2101_R01/Container_KSK2101_R01";
import { Container_KSK2110_R01 } from "src/containers/mes/KSK/KSK2110_R01/Container_KSK2110_R01";
import { Container_KSK2120_R01 } from "src/containers/mes/KSK/KSK2120_R01/Container_KSK2120_R01";
import { Container_KSK2130_R01 } from "src/containers/mes/KSK/KSK2130_R01/Container_KSK2130_R01";
import { Container_KSK2140_R01 } from "src/containers/mes/KSK/KSK2140_R01/Container_KSK2140_R01";


export const getMenuComponent = (menuCd: string) => {
    let component = null;

	if (menuCd === 'KSK1030_R01')		{ component = Container_KSK1030_R01;   }
	if (menuCd === 'KSK1070_R01')		{ component = Container_KSK1070_R01;   }
	if (menuCd === 'KSK1080_R01')		{ component = Container_KSK1080_R01;   }
	if (menuCd === 'KSK1081_R01')		{ component = Container_KSK1081_R01;   }
	if (menuCd === 'KSK1090_R01')		{ component = Container_KSK1090_R01;   }
	if (menuCd === 'KSK1110_R01')		{ component = Container_KSK1110_R01;   }
	if (menuCd === 'KSK1120_R01')		{ component = Container_KSK1120_R01;   }
	if (menuCd === 'KSK2010_R01')		{ component = Container_KSK2010_R01;   }
	if (menuCd === 'KSK2011_R01')		{ component = Container_KSK2011_R01;   }
	if (menuCd === 'KSK2020_R01')		{ component = Container_KSK2020_R01;   }
	if (menuCd === 'KSK2021_R01')		{ component = Container_KSK2021_R01;   }
	if (menuCd === 'KSK2022_R01')		{ component = Container_KSK2022_R01;   }
	if (menuCd === 'KSK2030_R01')		{ component = Container_KSK2030_R01;   }
	if (menuCd === 'KSK2040_R01')		{ component = Container_KSK2040_R01;   }
	if (menuCd === 'KSK2070_R01')		{ component = Container_KSK2070_R01;   }
	if (menuCd === 'KSK2080_R01')		{ component = Container_KSK2080_R01;   }
	if (menuCd === 'KSK2090_R01')		{ component = Container_KSK2090_R01;   }
	if (menuCd === 'KSK2101_R01')		{ component = Container_KSK2101_R01;   }
	if (menuCd === 'KSK2110_R01')		{ component = Container_KSK2110_R01;   }
	if (menuCd === 'KSK2120_R01')		{ component = Container_KSK2120_R01;   }
    if (menuCd === 'KSK2130_R01')		{ component = Container_KSK2130_R01;   }
    if (menuCd === 'KSK2140_R01')		{ component = Container_KSK2140_R01;   }
    
    
    return component;
};
